import React, { useState } from "react";
import styles from './FAQPage.module.scss';
import classNames from "classnames";
import { ArrowDownIcon } from "@kursk/components/ui/icons";

interface IProp {
  faq: any;
}

export const QuestionsAndAnswers = ({ faq }: IProp) => {
  const [isOpen, toggleIsOpen] = useState(false);

  const toggle = () => {
    toggleIsOpen(!isOpen);
  };

  return (
    <div className={classNames(styles.faq_questionsItem, isOpen && styles.open)} key={faq.createDate}>
      <div
        className={classNames(styles.faq_questionsItem__titleContainer,
          isOpen && styles.faq_questionsItem__titleContainer_open)}
        onClick={toggle}>
        <div
          className={classNames(styles.faq_questionsItem__title)}>
          {faq.name}
        </div>
        <ArrowDownIcon height={8} width={20}/>
      </div>
      <div className={
        classNames(!isOpen && styles.hidden, isOpen && styles.open, styles.faq_questionsItem__dropdown)}
      dangerouslySetInnerHTML={{ __html: faq.text }}>
      </div>
    </div>
  )
}
